import { TRIP_STATUS_MAP } from '@returnmates/client-core/src/constants/trip'
import { ConsolidationStatus } from '@returnmates/client-core/src/graphql/generated/api'

import { FilterPanelType, TableColumn } from '../GridTable/types'

export const COLUMNS_GRID: TableColumn[] = [
  {
    name: 'date',
    title: 'Created Date',
    filterable: false,
    searchable: false,
    sortingEnabled: true,
    width: 150,
  },
  {
    name: 'expectedDeliveryDate',
    title: 'Expected Departure Date',
    filterable: false,
    searchable: false,
    sortingEnabled: true,
    width: 150,
  },
  {
    name: 'id',
    title: 'Consolidation ID',
    filterable: false,
    searchable: false,
    sortingEnabled: true,
    width: 'auto',
  },
  {
    name: 'status',
    title: 'Status',
    filterable: true,
    filterPanelType: FilterPanelType.RADIO_GROUP,
    filterRadioOptions: TRIP_STATUS_MAP,
    searchable: false,
    sortingEnabled: true,
    width: 200,
  },
  {
    name: 'partnerName',
    title: 'Partner',
    filterable: false,
    searchable: false,
    sortingEnabled: true,
    width: 'auto',
  },
  {
    name: 'locationName',
    title: 'Location',
    filterable: false,
    searchable: false,
    sortingEnabled: true,
    width: 'auto',
  },
  {
    name: 'weight',
    title: 'Weight',
    filterable: false,
    searchable: false,
    sortingEnabled: true,
    width: 120,
  },
  {
    name: 'destination',
    title: 'Destination',
    filterable: false,
    searchable: false,
    sortingEnabled: true,
    width: 'auto',
  },
  {
    name: 'carrierName',
    title: 'Carrier',
    filterable: false,
    searchable: false,
    sortingEnabled: true,
    width: 150,
  },
]

export const DEFAULT_COLUMNS_WIDTH = COLUMNS_GRID.map(col => ({
  columnName: col.name,
  width: col.width,
}))

export const CONSOLIDATION_STATUSES_CHECKBOX = {
  type: 'status',
  values: [
    { key: ConsolidationStatus.PENDING, label: 'Pending' },
    { key: ConsolidationStatus.PACKED, label: 'Packed' },
    { key: ConsolidationStatus.DEPARTED, label: 'Departed' },
    { key: ConsolidationStatus.SHIPPED, label: 'Delivered' },
    { key: ConsolidationStatus.DELAYED_MISSORT, label: 'Delayed (Hub Missort)' },
  ],
}

export const FORMATTED_COLUMNS_NAMES = ['status', 'expectedDeliveryDate']
export const FORMATTED_COLUMNS = ['phone']

export const SEARCH_FIELDS = [
  { key: 'consolidationId', label: 'Consolidation ID' },
  { key: 'trackingId', label: 'Tracking ID' },
  { key: 'packageId', label: 'Package ID' },
  { key: 'destination', label: 'Destination' },
]
